<template>
  <v-btn-toggle
    :value="$i18n.locale"
    mandatory
    dense
    :class="['language-selector', `language-selector--${variant}`]"
    @change="changeLocale"
  >
    <v-btn
      v-for="language in languages"
      :key="language.value"
      small
      :value="language.value"
    >
      {{ language.text }}
    </v-btn>
  </v-btn-toggle>
</template>

<script>
import { setLocale } from '@/i18n'

export default {
  name: 'LanguageSelector',

  props: {
    variant: {
      type: String,
      default: 'default',
    },
  },

  data() {
    return {
      languages: [
        { value: 'es', text: 'ES' },
        { value: 'en', text: 'EN' },
        { value: 'pt', text: 'PT' },
      ],
    }
  },

  methods: {
    changeLocale(locale) {
      setLocale(locale)
    },
  },
}
</script>

<style scoped>
.language-selector {
  display: inline-flex;
  border-radius: 7px;
  overflow: hidden;
}

.language-selector ::v-deep .v-btn {
  min-width: 42px;
  height: 30px;
  font-size: 0.75rem;
  font-weight: 700;
  letter-spacing: 0;
}

.language-selector--landing {
  border: 1px solid rgba(74, 58, 255, 0.18);
  background: rgba(255, 255, 255, 0.94);
  box-shadow: 0 10px 26px rgba(45, 32, 95, 0.18);
}

.language-selector--landing ::v-deep .v-btn {
  color: #4a3aff;
  background: transparent !important;
}

.language-selector--landing ::v-deep .v-btn--active {
  color: white;
  background: #4a3aff !important;
}

.language-selector--login {
  border: 1px solid #ded8f6;
  background: #f8f7fd;
}

.language-selector--login ::v-deep .v-btn {
  color: #4a3aff;
  background: transparent !important;
}

.language-selector--login ::v-deep .v-btn--active {
  color: white;
  background: #4a3aff !important;
}

.language-selector--drawer {
  width: 100%;
  border: 1px solid #d5cef0;
  background: #f4f1fc;
}

.language-selector--drawer ::v-deep .v-btn {
  flex: 1;
  color: #3f3d56;
  background: transparent !important;
}

.language-selector--drawer ::v-deep .v-btn--active {
  color: white;
  background: #4a3aff !important;
}
</style>
